import { render, staticRenderFns } from "./CreateRoleForm.vue?vue&type=template&id=16fef95e&"
import script from "./CreateRoleForm.vue?vue&type=script&lang=js&"
export * from "./CreateRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports